export const theme = {
  colors: {
    background: '#0a192f',
    text: '#8892b0',
    primary: '#64ffda',
    secondary: '#112240',
    white: '#e6f1ff',
  },
  fonts: {
    main: "'Inter', sans-serif",
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
};
